import axios from "../../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/ai/promotionMarketingInstruction/list", {
        params: {
            ...params
        }
    } )
}

function EDIT_DATA(params) {
    return  axios.post("/ai/promotionMarketingInstruction/info",
      {id:params}
      )
}

function SUBMIT_EDIT(params) {
    return  axios.post("/ai/promotionMarketingInstruction/edit",{...params} )
}

function SUBMIT_ADD(params) {
    return  axios.post("/ai/promotionMarketingInstruction/add",{...params} )
}

function EDIT_STATUS(params) {
    return  axios.post("/ai/promotionMarketingInstruction/editStatus",{...params} )
}

export default {
    GET_LIST,
    EDIT_DATA,
    SUBMIT_EDIT,
    SUBMIT_ADD,
    EDIT_STATUS
}
